import { css } from '@emotion/css';

export const emojiStyles = css`
  .emoji-mart .emoji-mart-emoji {
    :focus {
      outline: none;
    }
  }

  .emoji-mart-category .emoji-mart-emoji span {
    cursor: pointer;
  }
`;
